// 無視したいエラーをここに定義する
import Bugsnag, { type Event } from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const IGNORE_ERROR_MESSAGES = [
  "Unexpected token '<'",
  'Request failed with status code 401',
  'SyntaxError: Unexpected identifier',
]

export const initializeBugsnag = (
  bugSnagApiKey: string,
  appVersion: string | undefined,
) => {
  if (bugSnagApiKey) {
    Bugsnag.start({
      apiKey: bugSnagApiKey,
      plugins: [new BugsnagPluginReact()],
      appVersion: appVersion,
      onError: (event: Event) => {
        const site: {
          siteName: string
          isPublicSite: boolean
        } = event.getMetadata('site')
        const errorMessage = event.errors?.[0]?.errorMessage
        const statusCode = event.originalError?.errors?.status

        const _isIgnore = () => {
          const ignoreMessage = IGNORE_ERROR_MESSAGES.some((msg) =>
            errorMessage?.includes(msg),
          )
          const isNotPublicSite = site && site.isPublicSite === false
          return ignoreMessage || isNotPublicSite
        }

        if (_isIgnore()) {
          return false
        }

        return statusCode !== 422
      },
    })
  }
}
